import {Grid, Typography} from '@mui/material';
import {useEffect, useState} from 'react';
import {useQueryClient} from 'react-query';
import {useDispatch, useSelector} from 'react-redux';
import {RootState} from '../../..';
import {LOANS_INFO} from '../../../config/cacheKey';
import {IGetLoansResponse} from '../../../models/registration.model';
import {getpervStateTab} from '../../../redux/loansTab/loansTabSlice';
import '../loanCard/loanCard.css';
import LoanCard from '../loanCard/loanCard';

type TStatus = 'other' | 'Assigned' | 'Settled' | 'CanceledBySetad';
const statusCardClass: Record<TStatus, string> = {
    other: 'loanCard-yellow',
    Assigned: 'loanCard-green',
    Settled: 'loanCard-blue',
    CanceledBySetad: 'loanCard-pink',
};

const statusColors: Record<TStatus, {light: string; dark: string}> = {
    other: {light: '#FFE8C5', dark: '#434343'},
    Assigned: {light: '#D3EBD5', dark: '#434343'},
    Settled: {light: '#D7DBEC', dark: '#434343'},
    CanceledBySetad: {light: '#FBE4E7', dark: '#434343'},
};
const statusBorderColors: Record<TStatus, string> = {
    other: '#FAD194',
    Assigned: '#B6E0B8',
    Settled: '#BCC3F1',
    CanceledBySetad: '#F4BDC5',
};

const AssignedLoanCard = () => {
    const dispatch = useDispatch();
    const queryClient = useQueryClient();
    const theme = useSelector((state: RootState) => state.theme);

    const loansInfo = queryClient.getQueryData<IGetLoansResponse>(LOANS_INFO);

    if (!loansInfo) {
        return null; // یا skeleton
    }

    const status: TStatus = statusColors[loansInfo.loanRequestStatus as TStatus]
        ? (loansInfo.loanRequestStatus as TStatus)
        : 'other';

    return (
        // <Grid
        //     container
        //     xs={12}
        //     className="rounded-[8px] mediaCardInfoDrawer"
        //     sx={{
        //         background:
        //             theme === 'dark'
        //                 ? statusColors[status].dark
        //                 : statusColors[status].light,
        //         position: 'relative',
        //         height: 'calc(33svh - 140px)',
        //     }}
        // >
        //     <Grid
        //         item
        //         sx={{
        //             width: '100%',
        //             height: '60%',
        //             display: 'flex',
        //             flexDirection: 'column',
        //             justifyContent: 'center',
        //             alignItems: 'center',
        //         }}
        //     >
        //         <Grid sx={{ display: 'flex', alignItems: 'center' }}>
        //             <b className="text-[var(--primary-text-color)] text-lg md:text-2xl">
        //                 {loansInfo.amount?.toLocaleString()}
        //             </b>
        //             <span className="text-xs text-[var(--primary-text-color)] mr-1">
        //                 ریال
        //             </span>
        //         </Grid>

        //         <Typography
        //             sx={{
        //                 color: '#BBA57A',
        //                 fontSize: '.875rem',
        //                 fontWeight: 'bold',
        //                 paddingY: '5px',
        //             }}
        //             onClick={() =>
        //                 dispatch(getpervStateTab({ prevState: 'loanDetail' }))
        //             }
        //         >
        //             مشاهده جزییات تسهیلات
        //         </Typography>
        //     </Grid>

        //     <Grid
        //         item
        //         container
        //         xs={12}
        //         className="!px-2 h-[35%] md:h-[40%]"
        //         sx={{
        //             margin: 'auto',
        //             borderRadius: '5px',
        //             boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.1)',
        //             background: statusBorderColors[status],
        //             alignItems: 'center',
        //         }}
        //     >
        //         <Grid xs={10} sx={{ display: 'flex', alignItems: 'center' }}>
        //             <b className="ml-1 text-[.9rem]">
        //                 {loansInfo.financialSupplierTitle}
        //             </b>
        //             <span className="text-xs">
        //                 ({loansInfo.durationTitle})
        //             </span>
        //         </Grid>

        //         <Grid xs={2} sx={{ display: 'flex', justifyContent: 'left' }}>
        //             <img
        //                 className="w-7 h-7 md:w-10 md:h-10"
        //                 src={`images/${loansInfo.financialSupplier ?? 'MellatBank'}.svg`}
        //                 style={{
        //                     objectFit: 'contain',
        //                     border: `2px solid ${statusBorderColors[status]}`,
        //                     borderRadius: '50%',
        //                     padding: '5px',
        //                     background: '#fff',
        //                 }}
        //             />
        //         </Grid>
        //     </Grid>
        // </Grid>
        <LoanCard
            status={loansInfo?.loanRequestStatus}
            price={String(loansInfo?.amount.toLocaleString())}
            financialProvider={loansInfo?.financialSupplierTitle}
            financialSupplierLogoUrl={loansInfo?.financialSupplierLogoUrl}
            insallmentStep={loansInfo?.durationTitle}
            inProgress={loansInfo?.financialSupplierTitle}
            statusTitle={loansInfo?.loanRequestStatusTitle}
            onClick={() => dispatch(getpervStateTab({prevState: 'loanDetail'}))}
        />
    );
};

export default AssignedLoanCard;
